// piePopupContent.js
import React from 'react';

import DataTablePopupComponent from './dataTablePopupComponent';
import SortPopupComponent from './sortPopupComponent';
import FilterPopupComponent from './filterPopupComponent';
import JoinPopupComponent from './joinPopupComponent';
import SummarizePopupComponent from './summarizePopupComponent';
import GroupByPopupComponent from './groupByPopupComponent';
import AppendPopupComponent from './appendPopupComponent';
import ExtractPopupComponent from './extractPopupComponent';
import LineChartPopupComponent from './lineChartPopupComponent';
import BarChartPopupComponent from './barChartPopupComponent';
import PieChartPopupComponent from './pieChartPopupComponent';
import ScatterChartPopupComponent from './scatterChartPopupComponent';



const piePopupContent = (selectedNodeId, closePopup, handleRemoveTable, node, handlePieSubmit, setNodes, nodes, droppedNodes, setDroppedNodes) => (
  <PieChartPopupComponent
    onClose={closePopup}
    onRemoveTable={handleRemoveTable}
    selectedNodeId={selectedNodeId}
    nodeName={node.data.label}
    onValueSubmit={handlePieSubmit}
    setNodes={setNodes}
    nodes={nodes}
    droppedNodes={droppedNodes}
    setDroppedNodes={setDroppedNodes}
    selectedCurrentDatabasesCombined={''}
    selectedCurrentTablesCombined={''}
    selectedColumnsCombined={''}
    selectedIdsOnly={''}
    selectedCombinedColumnsValue={''}
    selectedIdsCombinedColumnsValue={''}
    selectedLabelTypeValue={''}
  />
);


const barPopupContent = (selectedNodeId, closePopup, handleRemoveTable, node, handleBarSubmit, setNodes, nodes, droppedNodes, setDroppedNodes) => (
  <BarChartPopupComponent onClose={closePopup}
    onRemoveTable={handleRemoveTable}
    selectedNodeId={selectedNodeId}
    nodeName={node.data.label}

    onValueSubmit={handleBarSubmit}
    setNodes={setNodes} // Pass the callback function as a prop
    nodes={nodes} // Pass the nodes array as a prop
    droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
    setDroppedNodes={setDroppedNodes}
    selectedCurrentDatabasesCombined={''}
    selectedCurrentTablesCombined={''}
    selectedColumnsCombined={''}
    selectedCombinedColumnsValue={''}
    leftListValue={''}
    rightListValue={''}
    verticalLabelValue={''}
    horizantalLabelValue={''}
  />
);

const linePopupContent = (selectedNodeId, closePopup, handleRemoveTable, node, handleLineSubmit, setNodes, nodes, droppedNodes, setDroppedNodes) => (
  <LineChartPopupComponent onClose={closePopup}
    onRemoveTable={handleRemoveTable}
    selectedNodeId={selectedNodeId}
    nodeName={node.data.label}

    onValueSubmit={handleLineSubmit}
    setNodes={setNodes} // Pass the callback function as a prop
    nodes={nodes} // Pass the nodes array as a prop
    droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
    setDroppedNodes={setDroppedNodes}
    selectedCurrentDatabasesCombined={''}
    selectedCurrentTablesCombined={''}
    selectedColumnsCombined={''}
    selectedCombinedColumnsValue={''}
    leftListValue={''}
    rightListValue={''}
    verticalLabelValue={''}
    horizantalLabelValue={''}
  />
);


const scatterPopupContent = (selectedNodeId, closePopup, handleRemoveTable, node, handleLineSubmit, setNodes, nodes, droppedNodes, setDroppedNodes) => (
  <ScatterChartPopupComponent onClose={closePopup}
    onRemoveTable={handleRemoveTable}
    selectedNodeId={selectedNodeId}
    nodeName={node.data.label}

    onValueSubmit={handleLineSubmit}
    setNodes={setNodes} // Pass the callback function as a prop
    nodes={nodes} // Pass the nodes array as a prop
    droppedNodes={droppedNodes} // Pass the droppedNodes as a prop
    setDroppedNodes={setDroppedNodes}
    selectedCurrentDatabasesCombined={''}
    selectedCurrentTablesCombined={''}
    selectedColumnsCombined={''}
    selectedCombinedColumnsValue={''}
    leftListValue={''}
    rightListValue={''}
    verticalLabelValue={''}
    horizantalLabelValue={''}
  />
);


export { piePopupContent, barPopupContent, linePopupContent, scatterPopupContent };
